import StoredLayout from '../../layouts/StoredLayout'
import ProgressBars from './ProgressBars'
export default StoredLayout(ProgressBars)
